import { HttpResponse, http } from 'msw';
import { API, BASE_URL_V2 } from '../../../src/common/constants';
import { operatorsListMock } from '../data/operatorsListMock';

const URL = `${BASE_URL_V2}${API.endpoints.chargeStationOperators}`;

export default http.get(URL, async () => {
    const operators = operatorsListMock();
    return HttpResponse.json(operators);
});
